import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mission-section',
  templateUrl: './mission-section.component.html',
  styleUrls: ['./mission-section.component.css']
})
export class MissionSectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
